import { render, staticRenderFns } from "./BaseTipPopover.vue?vue&type=template&id=620fbd8a"
import script from "./BaseTipPopover.vue?vue&type=script&lang=js"
export * from "./BaseTipPopover.vue?vue&type=script&lang=js"
import style0 from "./BaseTipPopover.vue?vue&type=style&index=0&id=620fbd8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports